/* tslint:disable */
/* eslint-disable */
/**
 * Rapurc API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Metadata,
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './';

/**
 * Waste construction material object
 * @export
 * @interface Waste
 */
export interface Waste {
    /**
     * 
     * @type {string}
     * @memberof Waste
     */
    readonly id?: string;
    /**
     * Waste material ID
     * @type {string}
     * @memberof Waste
     */
    wasteMaterialId: string;
    /**
     * Usage ID
     * @type {string}
     * @memberof Waste
     */
    usageId: string;
    /**
     * Amount of waste material (tons)
     * @type {number}
     * @memberof Waste
     */
    amount: number;
    /**
     * More detailed description of the waste material
     * @type {string}
     * @memberof Waste
     */
    description?: string;
    /**
     * 
     * @type {Metadata}
     * @memberof Waste
     */
    metadata: Metadata;
}

export function WasteFromJSON(json: any): Waste {
    return WasteFromJSONTyped(json, false);
}

export function WasteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Waste {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'wasteMaterialId': json['wasteMaterialId'],
        'usageId': json['usageId'],
        'amount': json['amount'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function WasteToJSON(value?: Waste | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'wasteMaterialId': value.wasteMaterialId,
        'usageId': value.usageId,
        'amount': value.amount,
        'description': value.description,
        'metadata': MetadataToJSON(value.metadata),
    };
}


